<template>
  <a-modal
    title='可视化图表'
    :visible='visible'
    :confirm-loading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
    width='1300'
  >
    <div class='uvbigbox'>
      <div class='uvproductNameInstall'>
        <div style='margin-left: 5px'><h2>产品名称：{{ appNameValue }}</h2></div>

        <div v-if='dataarr.length>1' style='margin-left: 5px'><h2>
          日期：{{ dataarr[0] }}~{{ dataarr[dataarr.length - 1] }}</h2></div>
        <div v-else style='margin-left: 5px'><h2>日期：{{ dataarr[0] }}</h2></div>
        <div class='uvechrtsbox'
             style='display: flex;flex-direction: column;justify-content: space-around;'>
          <div class='uvechartsBox' ref='chartUvBox' style='width:96%; height: 1400px; margin-bottom: 100px;'></div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getUvList } from '@/webpublicapi/statistics'

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      productName: '产品名',
      startTime: '',
      endTime: '',
      myechartsOne: '',
      echartsDataList: [],
      appNameValue: '',
      dataarr: []
    }
  },
  created() {
    console.log('created')
  },
  mounted() {
    // this.confirmLoading = true
  },
  methods: {
    clearEcharts() {
      // console.log('准备清空echarts')
      // console.log('页面上有echats了吗myechartsOne---》', this.myechartsOne)
      // if (this.myechartsOne != null && this.myechartsOne != '' && this.myechartsOne != undefined) {
      //   console.log('清空')
      //   this.myechartsOne.dispose()
      // } else {
      //   console.log('不清空')
      // }
      // console.log('准备可以拿到dommdocument.querySelector(\'.uvechartsBox\')',document.querySelector('.uvechartsBox'))
      // // this.$echarts.init(document.querySelector('.uvechartsBox')).clear()
      // this.$echarts.init(document.querySelector('.uvechartsBox')).clear()
      // console.log('清空echarts~方法结束')
    },
    openModal() {
      console.log('open')
      this.visible = true
    },
    handleOk() {
      this.confirmLoading = false
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    //请求图的数据
    sendRequest(query) {
      // console.log('准备发请求的参数', query)
      // 发送请求的逻辑
      getUvList(query).then((res) => {
        if (res.code === 1000) {
          const datalist = res.data.rows
          console.log('准备处理给echarts的数据----》', datalist)

          // 拿产品名称
          this.appNameValue = res.data.appName
          // console.log(this.appNameValue)

          //
          // //没有数据的赋值为空
          // const allPointNames = [
          //   'CLICK_UP_BANK_INF_SUBMIT',
          //   'CLICK_LOAN_SUBMIT',
          //   'CLICK_CONFITM_SUBMIT',
          //   'CLICK_FIRST_CONFITM_SUBMIT',
          //   'CLICK_AMOUNT_SUBMIT',
          //   'CLICK_FIRST_AMOUNT_SUBMIT',
          //   'CLICK_WORK_INF_SUBMIT',
          //   'CLICK_BASIC_INF_SUBMIT',
          //   'CLICK_ID_INF_SUBMIT',
          //   'CLICK_ID_PICTURE_F_SUBMIT',
          //   'CLICK_BANK_INF_SUBMIT',
          //   'CLICK_CONTACT_INF_SUBMIT',
          //   'CLICK_INDEX_APPLY_SUBMIT',
          //   'CLICK_FIRST_INDEX_APPLY_SUBMIT',
          //   'CLICK_LOGIN_SUBMIT',
          //   'CLICK_LOGIN_CODE_SUCCESS',
          //   'SYSTEM_APP_OPEN',
          // ]

          // let arr = []
          // console.log('处理后的数据------------>1', arr)
          //
          // for (const item in datalist) {
          //   if(allPointNames.findIndex(pointName=>item.pointName===pointName)===-1){
          //     arr.push({
          //       'appssid': item.appssid,
          //       'curDate': item.curDate,
          //       'pointName': pointName,
          //       'value': 0
          //     })
          //   }else {
          //    // let item = datalist.find(pointName=>item.pointName===pointName)
          //     arr.push({
          //       'appssid': item.appssid,
          //       'curDate': item.curDate,
          //       'pointName': pointName,
          //       'value': item.value
          //     })
          //   }
          //
          //
          // }
          // // for (const pointName of allPointNames) {
          // //
          // // }
          // console.log('处理后的数据------------>2', arr)
          // // allPointNames.forEach(pointName=>{
          // //   console.log('pointName------------>', allPointNames)
          // //
          // //
          // // })

          // datalist.forEach(item => {
          //   const dateIndex = datalist.findIndex(dataItem => dataItem.curDate === item.curDate)
          //   console.log('dateIndexaaaaaaaaaaaaaaaaaaa',dateIndex)
          //   if (dateIndex === -1) {
          //     const newData = {
          //       'appssid': item.appssid,
          //       'curDate': item.curDate
          //     }
          //     allPointNames.forEach((pointName, i) => {
          //       newData.pointName = pointName
          //       newData.value = 0
          //       datalist.splice(dateIndex + i, 0, { ...newData })
          //     })
          //   } else {
          //     const existingPointNames = datalist.filter(dataItem => dataItem.curDate === item.curDate).map(dataItem => dataItem.pointName)
          //     allPointNames.forEach((pointName, i) => {
          //       if (!existingPointNames.includes(pointName)) {
          //         datalist.splice(dateIndex + i, 0, {
          //           'appssid': item.appssid,
          //           'curDate': item.curDate,
          //           'pointName': pointName,
          //           'value': 0
          //         })
          //       }
          //     })
          //   }
          // })

          // console.log('处理后的数据------------>', arr)


          this.dataarr = [...new Set(datalist.map(item => item.curDate))]
          // console.log('  this.dataarr---拿到所有的日期', this.dataarr)

          const newData = {}
          datalist.forEach(entry => {
            const { curDate, value } = entry
            if (newData[curDate]) {
              newData[curDate].push(value)
            } else {
              newData[curDate] = [value]
            }
          })
          console.log('拿到每个日期的按钮操作数值', newData)
          const resultArray = []
          Object.entries(newData).forEach(([date, data]) => {
            resultArray.push({
              name: date,
              type: 'bar',
              data: data,
              label: {
                show: true,
                position: 'right',
                color: 'black', // 文字颜色
                fontSize: 16,// 文字大小
                fontWeight: 'bold',
                formatter: function(params) {
                  if (params.value === 0) {
                    return '{a|' + params.value + '}'
                  } else {
                    return '{b|' + params.value + '}'
                  }
                },
                rich: {
                  a: {
                    color: 'red',
                    fontSize: 16
                  },
                  b: {
                    color: 'black',
                    // fontWeight: 'bold',
                    fontSize: 16
                  }
                }
              }
            })
          })
          console.log('resultArray最终的echarts要用到的数据', resultArray)
          this.echartsDataList = resultArray
          // this.$nextTick(() => {
            this.drawOneDay()
          // });

        }
      }).catch(e => {

      })
      setTimeout(() => {
        this.$echarts.init(document.querySelector('.uvechartsBox')).clear()
        this.drawOneDay()
      }, 1000)

    },
    //一天的画法
    drawOneDay() {
      console.log('调用了1天画图的方法', this.$refs)
      let chartDom = document.querySelector('.uvechartsBox')
      console.log('chartDom----------》', chartDom)
      this.$echarts.init(chartDom).clear()
      this.myechartsOne = this.$echarts.init(chartDom)

      let option

      option = {
        title: {
          text: '埋点uv统计'
        },
        tooltip: {
          formatter: function(params) {
            var content = ''
            params.forEach(item => {
              content += '<div style="padding:6px;">' + item.marker + item.axisValueLabel + '---' + item.seriesName + '---' + item.value + '</div>'
            })
            return content
          },
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: [
            'CLICK_UP_BANK_INF_SUBMIT (放款失败-点击更新银行卡)',
            'CLICK_LOAN_SUBMIT (点击申请成功确认按钮（OK按钮）)',
            'CLICK_CONFITM_SUBMIT (确认借款-复贷)',
            'CLICK_FIRST_CONFITM_SUBMIT (确认借款-首贷)',
            'CLICK_AMOUNT_SUBMIT (选择金额期限-复贷)',
            'CLICK_FIRST_AMOUNT_SUBMIT (选择金额期限-首贷)',
            'CLICK_WORK_INF_SUBMIT (点击工作信息提交按钮)',
            'CLICK_BASIC_INF_SUBMIT (点击基本信息提交按钮)',
            'CLICK_ID_INF_SUBMIT (点击身份信息提交按钮)',
            'CLICK_ID_PICTURE_F_SUBMIT (点击身份证-正面拍照)',
            'CLICK_BANK_INF_SUBMIT (点击银行卡信息提交按钮)',
            'CLICK_CONTACT_INF_SUBMIT (联系人信息提交按钮)',
            'CLICK_INDEX_APPLY_SUBMIT (点击申请按钮（复）)',
            'CLICK_FIRST_INDEX_APPLY_SUBMIT (点击申请按钮（首）)',
            'CLICK_LOGIN_SUBMIT (点击登录｜注册按钮)',
            'CLICK_LOGIN_CODE_SUCCESS (点击获取验证码)',
            'SYSTEM_APP_OPEN (启动APP-首次打开)',
          ]
        },
        series: this.echartsDataList
      }

      option && this.myechartsOne.setOption(option)
    }
  }
}
</script>

<style>
</style>